import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar-profile.component.html',
  styleUrl: './avatar-profile.component.scss'
})
export class AvatarProfileComponent {
  ngOnChanges(): void {
    const { boxColor, boxHeight, boxWidth, labelColor, labelSize, titleColor, titleSize, gap } = this.styles
    let addedStyles: any | IStyle = {}
    if (boxColor) addedStyles.boxColor = boxColor
    if (boxHeight) addedStyles.boxHeight = boxHeight
    if (boxWidth) addedStyles.boxWidth = boxWidth
    if (labelColor) addedStyles.labelColor = labelColor
    if (labelSize) addedStyles.labelSize = labelSize
    if (titleColor) addedStyles.titleColor = titleColor
    if (titleSize) addedStyles.titleSize = titleSize
    if (gap) addedStyles.gap = gap
    // this.styles = {...this.styles, ...addedStyles}
    for (let style in this.default) {
      if (addedStyles[style]) {
        // console.log("addedStyles[style]", addedStyles[style])
        this.styles_ = { ...this.styles_, [style]: addedStyles[style] }
      } else {
        this.styles_ = { ...this.styles_, [style]: this.default[style] }
      }
    }
    // console.log("this.styles", this.styles_)
  }

  @Input() title = ""
  @Input() label: string | null = ""
  @Input() round = false
  @Input() styles: IStyle = {}
  @Input() action: any = () => { }

  styles_: IStyle = {}

  default: IStyle | any = {
    boxWidth: "47px",
    boxHeight: "47px",
    titleSize: "13px",
    titleColor: "#374151",
    labelSize: "12px",
    labelColor: "#4B5563",
    boxColor: "#EDEEFF",
    gap: "10px"
  }

  get boxstyle() {
    return { 'width': this.styles_.boxWidth, 'height': this.styles_.boxHeight, 'min-height': this.styles_.boxHeight, background: this.styles_.boxColor }
  }
  get titleStyle() {
    return { 'fonst-size': this.styles_.titleSize, 'color': this.styles_.titleColor }
  }
  get labelStyle() {
    return { 'fonst-size': this.styles_.labelSize, 'color': this.styles_.labelColor }
  }

}

interface IStyle {
  boxWidth?: string,
  boxHeight?: string,
  titleSize?: string,
  titleColor?: string,
  labelSize?: string,
  labelColor?: string,
  boxColor?: string,
  gap?: string
}
